import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";

const faqs = [
  {
    q: "投稿后我的身份会被暴露吗？",
    a: "不会。投稿入口不采集 IP 与设备指纹，表单中也没有任何强制身份字段。若你在正文里写到了可识别自身的信息，编辑会先做脱敏处理再归档。",
  },
  {
    q: "什么样的内容适合投稿？",
    a: "与行业运作相关、可被描述清楚的事实类信息最合适，例如排期安排、结算方式、执行流程、合作结构。纯粹的传闻、无法描述来源的二手消息，我们会归入低优先级。",
  },
  {
    q: "「待核验」是不是说明这条线索不可信？",
    a: "不是。它只表示目前只有一位来源提供了说法，尚未找到第二个独立信源。等级会随着新证据出现而调整，我们会在原线索下方持续更新。",
  },
  {
    q: "你们会删除已经发布的线索吗？",
    a: "会。若当事人提供了可推翻关键事实的证据，我们会更正或下线相关条目，并在同一位置留下更正说明，不做静默删除。",
  },
  {
    q: "可以匿名投稿多条线索吗？",
    a: "可以，每条线索单独提交一次即可，便于我们分别建立编号与核验状态。同一事件的不同环节，也建议拆成多条分别说明。",
  },
  {
    q: "投稿之后多久能看到结果？",
    a: "夜班编辑会在 24 小时内完成初步整理与分级。进入核验阶段的线索，通常在 3 至 7 日内决定是否公开发布；未发布的线索不会丢弃，会保留在待核区。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-100">
      <div className="wrap py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="07"
              eyebrow="FAQ"
              title="投稿前，你可能想知道"
              desc="关于匿名性、核验标准与内容处理的常见疑问，先看这里。"
            />
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-background-300">
              {faqs.map((item, index) => {
                const isOpen = open === index;
                return (
                  <div key={item.q} className="border-b border-background-300">
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpen(isOpen ? -1 : index)}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                      >
                        <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                            isOpen
                              ? "border-primary-500 bg-primary-500 text-background-50"
                              : "border-background-400 text-foreground-600"
                          }`}
                        >
                          <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                        </span>
                      </button>
                    </h3>
                    {isOpen ? (
                      <p className="pb-6 pr-12 text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}